import { render, staticRenderFns } from "./TransporterDetails.vue?vue&type=template&id=7c27d2ad&scoped=true"
import script from "./TransporterDetails.vue?vue&type=script&lang=ts"
export * from "./TransporterDetails.vue?vue&type=script&lang=ts"
import style0 from "./TransporterDetails.vue?vue&type=style&index=0&id=7c27d2ad&lang=scss"
import style1 from "./TransporterDetails.vue?vue&type=style&index=1&id=7c27d2ad&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c27d2ad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/CONA-CRM/Admin/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c27d2ad')) {
      api.createRecord('7c27d2ad', component.options)
    } else {
      api.reload('7c27d2ad', component.options)
    }
    module.hot.accept("./TransporterDetails.vue?vue&type=template&id=7c27d2ad&scoped=true", function () {
      api.rerender('7c27d2ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/transporters/components/TransporterDetails.vue"
export default component.exports